import React from 'react'
import About from '../container/About/About'
import AboutText from '../components/AboutText/AboutText'
import Skills from '../container/Skills/Skills'
import Works from '../container/Works/Works'

const Main = () => {
  return (
    <main>
        <About/>
        <AboutText/>
        <Skills/>
        <Works/>
    </main>
  )
}

export default Main